import { CAppusers } from "./../../views/app-services/system-interface";
import { GetDataService } from "./../../views/app-services/manage-data.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { navItems } from "./../../_nav";
@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html",
})
export class DefaultLayoutComponent implements OnDestroy {
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  public userLoggedIn: CAppusers[] = new Array<CAppusers>();
  public loggedName: string;
  public username: string;
  public avatar: string;
  public isAdmin: boolean;
  public loggedUser;
  constructor(private dataServer: GetDataService) {
    const userInfo = JSON.parse(sessionStorage.getItem("userDetails"));
    // console.log(userInfo.username);
    this.username = userInfo.username;
    this.dataServer.cast.subscribe(
      (userLoggedIn) => (this.userLoggedIn = userLoggedIn)
    );
    // console.log('from user default');
    // console.log(this.userLoggedIn);
    // console.log(this.userLoggedIn[0].FirstName);
    // console.log(this.userLoggedIn[0].LastName);
    // console.log(this.userLoggedIn[0].avatar);
    if (Object.keys(this.userLoggedIn).length === 0) {
      // window.location.href = '#/login';
    } else {
      if (this.userLoggedIn[0].userType === "A") {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }
    }

    if (this.userLoggedIn === undefined) {
      console.log("undefined");
    } else {
      if (this.userLoggedIn.length > 0) {
        if (this.userLoggedIn[0].name === null) {
          this.loggedName =
            this.userLoggedIn[0].FirstName +
            " " +
            this.userLoggedIn[0].LastName;
          console.log(this.loggedName);
          this.avatar = this.userLoggedIn[0].avatar;
          console.log(this.avatar);
        } else {
          this.loggedName = this.userLoggedIn[0].name;
        }
      }
    }
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized =
        document.body.classList.contains("sidebar-minimized");
    });

    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  ngOnInit() {
    this.loggedUser = JSON.parse(sessionStorage.getItem("userDetails"));
    // console.log("thi sis the real user");
    // console.log(this.loggedUser);
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }
}
